export default __webpack_public_path__ + "static/media/flag-nauru.7ab6a5bf.svg";